import React from "react";
import { Col, Container } from "react-bootstrap";
import slider1 from "../../../../img/slider/index-header-01.jpg";

const HeroSection = () => {
  return (
    <div>
      <div className="hero-background">
        <img className="img-fluid" src={slider1} alt="" />
      </div>
      <Container>
        <div className="hero-section">
          <Col md={{ span: 5, offset: 7 }} sm="12">
            <blockquote className="text-white blockquote blockquote-text">
              <p className="hero-title-text">
                " At our farm, we`re working to bring organic to everyone.''
              </p>
              <figcaption className="blockquote-footer">
                <cite title="Tom &amp; Marta Johnsons"> Owner Of the Store</cite>
              </figcaption>
            </blockquote>
          </Col>
        </div>
      </Container>
    </div>
  );
};

export default HeroSection;
